var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.isVrMode && !_vm.isFullscreen,
          expression: "!isVrMode && !isFullscreen",
        },
      ],
      staticClass: "i-header",
    },
    [
      _c("div", {
        staticClass: "header-intro",
        class: { "screen-ready": _vm.isScreenReady },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-center",
          class: { "screen-ready": _vm.isScreenReady },
        },
        [
          !_vm.isHideLiveTourName
            ? _c(
                "div",
                {
                  staticClass: "header-title",
                  class: {
                    active: _vm.isModalBuildingInfoVisble,
                    "pointer-cursor":
                      _vm.hasDescription || _vm.hasAdvertiseLink,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "header-title-inner",
                      on: { click: _vm.onTitleClick },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentBuilding.nameMulti[_vm.lang] ||
                              _vm.currentBuilding.name
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.hasDescription
                        ? _c("i", {
                            staticClass: "isif",
                            class: _vm.isModalBuildingInfoVisble
                              ? "isif-arrow-up"
                              : "isif-arrow-down",
                          })
                        : _vm.hasAdvertiseLink
                        ? _c("i", { staticClass: "isif isif-foreign" })
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("portrait", {
        staticClass: "portrait",
        attrs: { "dropdown-position": "right" },
      }),
      _vm._v(" "),
      _c("ModalBuildingInfo", {
        ref: "ModalBuildingInfo",
        on: {
          opened: _vm.onModalBuildingInfoOpened,
          closed: _vm.onModalBuildingInfoClosed,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }